import createRouter from '@wikom/wikom-router';
import routeConfig from './routeConfig';
var _a = createRouter(routeConfig), RouteProvider = _a.RouteProvider, useRoute = _a.useRoute, useDef = _a.useDef, usePrefix = _a.usePrefix;
export { RouteProvider, useRoute, useDef, usePrefix, };
